import { Route } from "@angular/router";
import { Permissions } from "../../../access/shared/authorization/permissions";
import { DeliveryListComponent } from "./delivery-list.component";

export const DeliveryListRouting: Route = {
  path: "list",
  component: DeliveryListComponent,
  data: {
    breadcrumb: "Liste",
    'notRole': [
      Permissions.ROLE_LECTURECAB,
    ],
    'redirect': [
      '/delivery/schedule',
    ],
  }
};
